import {
  Pipe,
  PipeTransform
} from "@angular/core";


@Pipe({
    name: "statutOperOf",
    standalone: true
})
export class StatutOperOfPipe implements PipeTransform {
  transform(value: string): any {
    const statut = (() => {
      switch (value) {
        case "P":
          return "Prévu";
        case "F":
          return "Ferme";
        case "E":
          return "En-cours";
        case "L":
          return "Lancé";
        case "T":
          return "Terminé";
        default:
          return "Statut inconnu";
      }
    })();
    return statut;
  }
}
